// extracted by mini-css-extract-plugin
export default {"tag":"footer_tag__mhOfn","menu":"footer_menu__AXkm6","donate":"footer_donate__pnARt","support":"footer_support__D-LWu"};